import React, { useEffect, useState, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { TabProvider } from '@tecuity/granite-ui/TabProvider'
import { TabPanel } from '@tecuity/granite-ui/TabPanel'
import { TabButton } from '@tecuity/granite-ui/TabButton'
import { SET_RECORD_DETAILS } from '../RecordDetailsReducer'
import { Body } from 'components/Shell/Shell'
import { useRequestData } from '../../../Utilities/hooks'
import * as api from '../../../requests'
import GenericDetails from '../GenericDetails'
import NotesPanel from '../NotesPanel'
import { saveNewNote, editNote, deleteNote, getEntityNotes } from '../RecordDetailsActions'
import RecordHistory from 'components/RecordHistory/RecordHistory'
import RepresentedBusinessRecords from './RepresentedBusinessRecords'
import { Spinner } from '../../Loaders/Loaders'
import RecordDetailPageBackButton from '../RecordDetailPageBackButton'
import { useLocation } from 'react-router'

const DataRequestRecordDetails = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  // const {appUserRights} = useSelector((state) => state.auth, shallowEqual);
  const { recordDetails: record } = useSelector((state) => state.record, shallowEqual)
  const RecordDetailsSettings = useRequestData((cb, ecb) =>
    api.GET_RECORD_DETAIL_SETTING_BY_TYPE('RegisteredAgentRecordDetail', cb, ecb)
  )
  const [activeTabId, setActiveTabId] = useState('tab-0')
  const [loading, setLoading] = useState(false)

  const recordNum = useMemo(() => {
    const parts = location.pathname.split('/')
    return parts[parts.length - 1]
  }, [location.pathname])

  useEffect(() => {
    setLoading(true)
    api.FETCH_REGISTERED_AGENT_RECORD_DETAILS(
      recordNum,
      (details) => {
        dispatch({ type: SET_RECORD_DETAILS, record: details })
        dispatch(getEntityNotes(157, details.RegisteredAgentRecordId))
        setLoading(false)
      },
      (err) => {
        console.error(err)
        setLoading(false)
      }
    )
  }, [recordNum])

  const saveNote = (note) => {
    dispatch(saveNewNote(note, 157, record.RegisteredAgentRecordId))
  }

  const editAgentNote = (note) => {
    dispatch(editNote(note, 157, record.RegisteredAgentRecordId))
  }

  const deleteAgentNote = (noteId) => {
    dispatch(deleteNote(noteId, 157, record.RegisteredAgentRecordId))
  }

  if (!RecordDetailsSettings || loading) {
    return (
      <div style={{ height: '100%', width: '100%', textAlign: 'center', padding: '4rem' }}>
        <Spinner className="page-loader" themeColor="dark-neutral" />
      </div>
    )
  }

  return (
    <Body
      className="no-padding"
      /*showDrawer={showDrawer}*/ hiddenTitle="Registered Agent Record Details"
    >
      <TabProvider activeTabId={activeTabId} onChange={(id) => setActiveTabId(id)}>
        <div className="row header-row">
          <h1>Registered Agent Record Details</h1>
          <div className="tablist" role="tablist">
            {RecordDetailsSettings &&
              (RecordDetailsSettings.Tabs || []).map(
                (tab, i) =>
                  tab.Title !== 'General' && (
                    <TabButton
                      key={`tab-${i}`}
                      id={`tab-${i}`}
                      forPanelId={`panel-${i}`}
                      label={tab.Title}
                    />
                  )
              )}
          </div>
        </div>
        <GenericDetails record={record} config={RecordDetailsSettings || {}} />

        <div>
          {RecordDetailsSettings &&
            (RecordDetailsSettings.Tabs || []).map(
              (tab, i) =>
                tab.Title !== 'General' && (
                  <TabPanel
                    key={`panel-${i}`}
                    id={`panel-${i}`}
                    tabId={`tab-${i}`}
                    label={tab.Title}
                  >
                    {tab.Title === 'Notes' ? (
                      <NotesPanel
                        saveNote={saveNote}
                        editNote={editAgentNote}
                        deleteNote={deleteAgentNote}
                      />
                    ) : tab.Title === 'Represented Records' ? (
                      <RepresentedBusinessRecords
                        fieldSettings={
                          RecordDetailsSettings.FieldSettings.RepresentedRecords.Fields
                        }
                        records={record.RepresentedRecords}
                      />
                    ) : tab.Title === 'History' ? (
                      <RecordHistory
                        history={{
                          amendments: record.history.AmendmentList || [],
                          history: record.history.HistoryList || [],
                          template:
                            RecordDetailsSettings.HistoryConfig.filter((t) => t.enabled) || [],
                        }}
                        requiredVoidRight="RegisteredAgentVoid"
                      />
                    ) : (
                      'No information for tab'
                    )}
                  </TabPanel>
                )
            )}
        </div>
      </TabProvider>
      <RecordDetailPageBackButton />
    </Body>
  )
}

export default DataRequestRecordDetails
